import { useToast } from "../../hooks/ToastContext";

function Fesignin({
  contestPageDetails,
  signinEntry,
  inputs,
  setInputs,
  feSignin,
  clickloginBtn,
  isRegLoading,
}) {
  const entrydet = JSON.parse(signinEntry.entry);
  const { showToast } = useToast();
  const handleChange = (e) => {
    setInputs((inputs) => {
      return {
        ...inputs,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleForgotPassword = () => {
    clickloginBtn("forgotpassword");
  };

  const signin = () => {
    // Email Validation Regex Pattern
    const validateEmail = (email) => {
      return /\S+@\S+\.\S+/.test(email);
    };

    if (!inputs.email?.trim()) {
      showToast("warning", "Email should not be empty");
      return;
    }
    if (!validateEmail(inputs.email)) {
      showToast("warning", "Please enter a valid Email");
      return;
    }
    if (!inputs.password?.trim()) {
      showToast("warning", "Password should not be empty");
      return;
    }
    feSignin();
  };

  return (
    <div className="relative flex justify-center items-center md:p-8">
      <div className=" md:mt-[-135px] mt-[-90px] md:pb-3 pb-8">
        <div className="w-[280px] md:w-[648px] bg-white shadow-md rounded-lg opacity-100">
          <div className="primary_light_bgcolor2 bg-[#E1EDF9] p-6 text-center rounded-t-lg">
            <h2 className="text-center text-black md:text-[17px] sm:leading-[20px] sm:text-[12px] font-medium opacity-100 md:mb-2">
              {entrydet?.headline}
            </h2>
            <h4 className="text-[13px] md:p-1 leading-4 text-black/60">
              {entrydet?.signin_sub_title}
            </h4>
          </div>

          <div className="p-4 md:p-10">
            <div className="mb-5">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                {entrydet?.email || "Enter Your Email"}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                onChange={handleChange}
                value={inputs?.email || ""}
                className="bg-white input_focus_primary border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder={entrydet?.email || "Enter Your Email"}
                required
              />
            </div>
            <div className="mb-5">
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                {entrydet?.password || "Enter Your Password"}
              </label>
              <input
                type="password"
                id="password"
                name="password"
                onChange={handleChange}
                value={inputs?.password || ""}
                className="bg-white input_focus_primary border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder={entrydet?.password || "Enter Your Password"}
                required
              />
            </div>

            <div className="flex justify-end mt-4">
              <button
                type="button"
                onClick={handleForgotPassword}
                className="group relative text-sm flex primary_text_color tracking-wide items-center gap-0.5 leading-none"
              >
                Forgot your password?
                <span className="absolute -bottom-0.5 left-0 h-[2px] w-full primary_btn_bg scale-x-0 origin-left transition-transform duration-500 ease-out group-hover:scale-x-100"></span>
              </button>
            </div>

            <div className="w-full mt-5">
              <button
                onClick={() => signin()}
                disabled={isRegLoading}
                className="primary_btn_bg text-center font-bold text-[14px] leading-[25px] tracking-[0px] text-white bg-[#0274F7] p-3 w-full rounded-md hover:bg-white hover:text-blue-500 border hover:border-blue-500 transition duration-200 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {entrydet?.signin_btn_text || "Sign In"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Fesignin;
